import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/** Reset window scroll when navigating between routes (SPA does not do this by default). */
export default function ScrollToTop() {
    const { pathname, search } = useLocation();

    useLayoutEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname, search]);

    return null;
}
